import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { ResponsiveImage, ResponsiveImageSize } from 'react-responsive-image';
import SmallQuote from './SmallQuote.jsx';
import styleHelper from './../../../helpers/style';
import actions from './../../../actions/small-card-actions';


class SmallImageCard extends React.Component {
  constructor(props) {
    super(props);

    // used by React as the component name
    this.displayName = 'SmallImageCard';

    // timeout to show or hide the image credits
    this.showHideCreditsTimeout = 0;

    // if the image is loaded
    this.imageLoaded = false;

    // height of the quote, if there is one
    this.quoteHeight = 0;

    // bind functions to component
    this.onImageLoad = this.onImageLoad.bind(this);
    this.sizeImage = this.sizeImage.bind(this);
    this.toggleCredits = this.toggleCredits.bind(this);
    this.renderCreditsButton = this.renderCreditsButton.bind(this);
    this.renderCredits = this.renderCredits.bind(this);
    this.renderQuote = this.renderQuote.bind(this);
  }


  /**
   * Called when component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    if (this.refs.quote) {
      this.quoteHeight = ReactDOM.findDOMNode(this.refs.quote).offsetHeight;
    }
  }


  /**
   * Called when component props or state updates
   * @param {Object} prevProps - The previous props
   * @returns {undefined} undefined
   */
  componentDidUpdate(prevProps) {
    const data = this.props.data;
    const state = this.props.smallCardFrameworkState;
    const prevState = prevProps.smallCardFrameworkState;
    const active = (state.currentCardIteration + 1 === data.order);
    const prevActive = (prevState.currentCardIteration + 1 === data.order);
    const globalState = this.props.mediaLabCardFrameworkState;
    const windowSize = globalState.windowSize;
    const prevWindowSize = prevProps.mediaLabCardFrameworkState.windowSize;

    if (((windowSize.width !== prevWindowSize.width) ||
      windowSize.height !== prevWindowSize.height)) {
      this.sizeImage();
    }

    if (active && !prevActive && !this.imageLoaded) {
      this.props.dispatch(actions.setLoading(true));
    }
  }


  /**
   * Called when component unmounts
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    this.imageLoaded = false;
  }


  /**
   * Renders credits button
   * @returns {ReactElement} ReactElement
   */
  renderCreditsButton() {
    const data = this.props.data;
    let element;

    if (data.credits) {
      element = (
        <div
          className='credits-button'
          onClick={this.toggleCredits}
        >
          <div className='icon'>
            <div className='line-1' />
            <div className='line-2' />
          </div>
        </div>
      );
    }

    return element;
  }


  /**
   * Renders credits
   * @returns {ReactElement} ReactElement
   */
  renderCredits() {
    const globalState = this.props.mediaLabCardFrameworkState;
    const data = this.props.data;
    let element;

    if (data.credits) {
      const creditsStyle = {};
      /* const creditsContainerStyle = {
        height: globalState.windowSize.height - this.quoteHeight,
      }; */
      if (this.refs.credits) {
        const containerHeight = this.refs.creditsContainer.offsetHeight;
        creditsStyle.marginTop =
          (containerHeight / 2) -
          (this.refs.credits.offsetHeight / 2) - 60;
      }
      const credits = [];

      for (let i = 0; i < data.credits.data.length; i++) {
        const creditsData = data.credits.data[i];
        const items = [];

        for (let ii = 0; ii < creditsData.items.length; ii++) {
          items.push(
            <li
              dangerouslySetInnerHTML={{ __html: creditsData.items[ii] }}
              className='item'
              key={'image-credit-item-' + i + '-' + ii + '-' + data.order}
            />
          );
        }

        credits.push(
          <div
            className='credit'
            key={'image-credit-item-' + i + '-' + data.order}
          >
            <div
              className='title'
              dangerouslySetInnerHTML={{ __html: creditsData.title }}
            />
            <ul className='items'>
              {items}
            </ul>
          </div>
        );
      }

      element = (
        <div
          ref='creditsContainer'
          className='credits'
        >
          <div
            className='background'
            style={{ backgroundColor: data.credits.bgColor }}
          />
          <div
            className='credit-wrapper'
            ref='credits'
            style={creditsStyle}
          >
            {credits}
          </div>
        </div>
      );
    }

    return element;
  }


  /**
   * Renders quote
   * @returns {ReactElement} ReactElement
   */
  renderQuote() {
    const data = this.props.data;
    let element;

    if (data.quote) {
      element = (
        <SmallQuote
          ref='quote'
          data={data.quote}
          position={'bottom'}
        />
      );
    }

    return element;
  }


  /**
   * Called when the image is loaded
   * @returns {undefined} undefined
   */
  onImageLoad() {
    const state = this.props.smallCardFrameworkState;
    const data = this.props.data;
    const active = ((state.currentCardIteration + 1) === data.order);

    this.imageLoaded = true;

    if (active) {
      this.props.dispatch(actions.setLoading(false));
    }

    this.sizeImage();
  }


  /**
   * Sizes the image
   * @returns {undefined} undefined
   */
  sizeImage() {
    const data = this.props.data;
    const globalState = this.props.mediaLabCardFrameworkState;
    const windowSize = globalState.windowSize;
    let containerSize = windowSize;
    if (data.quote) {
      containerSize = {
        width: windowSize.width,
        height: windowSize.height - this.quoteHeight,
      };
    }
    const currentSize = (windowSize.width < this.props.largeBreakpoint) ?
      data.size : data.largeSize;
    const imageStyle = styleHelper.getSizeToCover(
      currentSize.width,
      currentSize.height,
      containerSize.width,
      containerSize.height
    );

    if (!data.centerVertically) {
      imageStyle.marginTop = 0;
    }

    this.props.dispatch(actions.setImageStyle(imageStyle, data.order));
  }


  /**
   * Toggles credits
   * @returns {undefined} undefined
   */
  toggleCredits() {
    const state = this.props.smallImageCardState;
    const data = this.props.data;

    clearTimeout(this.showHideCreditsTimeout);

    if (state.imageCards[data.order] &&
      state.imageCards[data.order].showCredits) {
      this.props.dispatch(actions.transitionOutImageCredits(data.order));
      this.showHideCreditsTimeout = setTimeout(() => {
        this.props.dispatch(actions.hideImageCredits(data.order));
      }, 210);
    } else {
      this.props.dispatch(actions.showImageCredits(data.order));
      this.showHideCreditsTimeout = setTimeout(() => {
        this.props.dispatch(actions.transitionInImageCredits(data.order));
      }, 10);
    }

    this.props.dispatch(actions.setCardClickPrevented(true));

    setTimeout(() => {
      this.props.dispatch(actions.setCardClickPrevented(false));
    }, 100);
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const creditsButton = this.renderCreditsButton();
    const credits = this.renderCredits();
    const quote = this.renderQuote();
    const state = this.props.smallImageCardState;
    const frameworkState = this.props.smallCardFrameworkState;
    const data = this.props.data;
    const activeClass = ((frameworkState.currentCardIteration + 1) === data.order) ?
      ' active' : '';
    let imageStyle = {};
    let showCreditsClass = '';
    let transitionInCreditsClass = '';
    if (state.imageCards[data.order]) {
      if (state.imageCards[data.order].style) {
        imageStyle = state.imageCards[data.order].style;
      }

      if (state.imageCards[data.order].showCredits) {
        showCreditsClass = ' show-credits';
      }

      if (state.imageCards[data.order].transitionInCredits) {
        transitionInCreditsClass = ' transition-in-credits';
      }
    }

    const className = 'card component-small-image-card' +
      activeClass +
      showCreditsClass +
      transitionInCreditsClass;

    return (
      <section
        className={className}
        style={this.props.style}
      >
        <div className='image'>
          <ResponsiveImage
            imageStyle={imageStyle}
            ref='image'
            onLoad={this.onImageLoad}
          >
            <ResponsiveImageSize
              default
              minWidth={0}
              path={data.path}
            />
            <ResponsiveImageSize
              minWidth={768}
              path={data.largePath}
            />
          </ResponsiveImage>
        </div>
        {quote}
        {credits}
        {creditsButton}
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Function} dispatch - A Redux function to dispatch events
 * @prop {Object} imageCardState- The state of the
 * ImageCard components
 * @prop {Number} iteration - The iteration of the component
 * @prop {Number} largeBreakpoint - A width breakpoint
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 * @prop {Object} style - A style object
 */
SmallImageCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  dispatch: React.PropTypes.func,
  smallImageCardState: React.PropTypes.object.isRequired,
  iteration: React.PropTypes.number.isRequired,
  largeBreakpoint: React.PropTypes.number,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};

export default connect(({
  mediaLabCardFrameworkState,
  smallCardFrameworkState,
  smallImageCardState }) =>
  ({
    mediaLabCardFrameworkState,
    smallCardFrameworkState,
    smallImageCardState,
  }))(SmallImageCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/small/SmallImageCard.jsx
 **/